import React, { DetailedHTMLProps, HTMLAttributes } from 'react';
import {
  CheckMarkStyled,
  VideoThumbnailContainerStyled,
} from './thumbnail-image-upload-viewer.styled';
import { IconSize } from '@constants';
import { useTheme } from '@mui/material';
import { CheckIcon } from '@heroicons/react/24/outline';

export interface ThumbnailImageUploadViewerProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  imageUrl: string | undefined;
  isSelected: boolean;
}

const ThumbnailImageUploadViewer = ({
  isSelected,
  imageUrl,
  ...props
}: ThumbnailImageUploadViewerProps) => {
  const theme = useTheme();
  return (
    <VideoThumbnailContainerStyled {...props} isSelected={isSelected}>
      <img
        src={
          imageUrl?.startsWith('http') ? `${imageUrl}?${new Date()}` : imageUrl
        }
        alt="Uploaded"
      />
      {isSelected && (
        <CheckMarkStyled>
          <CheckIcon height={IconSize.sm} color={theme.palette.white.main} />
        </CheckMarkStyled>
      )}
    </VideoThumbnailContainerStyled>
  );
};

export default ThumbnailImageUploadViewer;
